import React from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';

export function ReadRestrictions() {
  return (
    <span className="main-navigation__link-restricted">
      <SVG svgSpriteId={Icons.CLOSED_LOCK} />
    </span>
  );
}
